import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { traducirTexto } from '../i18n/catalogo';

const STORAGE_KEY = 'idiomaAplicacion';
export const obtenerIdiomaActual = () => {
  try { return localStorage.getItem(STORAGE_KEY) === 'en' ? 'en' : 'es'; }
  catch (_) { return 'es'; }
};
const idiomaInicial = () => {
  return obtenerIdiomaActual();
};

const IdiomaContext = createContext({ idioma: 'es', establecerIdioma: () => {}, t: (texto) => texto });

export function IdiomaProvider({ children }) {
  const [idioma, setIdioma] = useState(idiomaInicial);
  const establecerIdioma = useCallback((nuevo) => {
    const valido = nuevo === 'en' ? 'en' : 'es';
    try { localStorage.setItem(STORAGE_KEY, valido); } catch (_) {}
    setIdioma(valido);
  }, []);
  const value = useMemo(() => ({ idioma, establecerIdioma, t: (texto) => traducirTexto(texto, idioma) }), [idioma, establecerIdioma]);
  return <IdiomaContext.Provider value={value}>{children}</IdiomaContext.Provider>;
}

export const useIdioma = () => useContext(IdiomaContext);
export default IdiomaContext;
